<template>
    <div class="course-detail container py-4">
        <div class="row">
            <div v-if="loading" class="col-12 text-center py-5">
                <span>Loading...</span>
            </div>

            <div v-else-if="videoLessons.length === 0" class="col-12 text-center py-5">
                <span>Course Details not found.</span>
            </div>

            <div v-else class="col-12 col-md-8 offset-md-2">
                <!-- Back Button -->
                <!-- <div class="mb-3">
                    <button class="btn btn-outline-secondary" @click="$router.push({ name: 'courses.list' })">
                        <i class="fa fa-arrow-left me-2"></i>
                        Back to Courses
                    </button>
                </div> -->
                <!-- 1. Hero Section -->
                <section v-if="imageLoading" class="hero-section hero-skeleton shimmer"></section>
                <section v-else
                    class="hero-section position-relative d-flex flex-column align-items-center justify-content-center text-white text-center"
                    :style="{ backgroundImage: `url(${courseHeroImageBlobUrl})` }">

                    <!-- Overlay -->
                    <div class="hero-overlay position-absolute top-0 start-0 w-100 h-100 bg-black opacity-50"></div>

                    <!-- Breadcrumbs -->
                    <!-- <nav aria-label="breadcrumb" class="position-relative z-1 mb-2">
                        <ol class="breadcrumb bg-transparent p-0 m-0 text-white">
                            <li class="breadcrumb-item fs-5">
                                <router-link :to="{ name: 'staff.training-courses' }"
                                    class="text-white text-decoration-none">Training Courses</router-link>
                            </li>
                            <li class="breadcrumb-item active text-white fs-4" aria-current="page">{{ course.title }}
                            </li>
                        </ol>
                    </nav> -->

                    <!-- Title -->
                    <!-- <h1 class="display-5 display-md-4 fw-bold position-relative z-1">{{ course.title }}</h1> -->
                </section>

                <!-- 2. Description -->
                <div class="card mb-4">
                    <div class="card-body course-meta">
                        <div class="d-lg-flex justify-content-lg-between course-title">
                            <button class="d-block d-lg-none btn btn-outline-primary btn-sm mb-4" @click="goToCourses">
                                <i class="fa fa-arrow-left me-2"></i>
                                BackTo Courses
                            </button>
                            <h2 class="course-title">{{ course.title }}</h2>
                            <button class="d-none d-lg-block btn btn-outline-primary btn-sm" @click="goToCourses">
                                <i class="fa fa-arrow-left me-2"></i>
                                Back To Courses
                            </button>
                        </div>
                        <div class="course-description">
                            <p class="fs-6 fs-md-5">
                                {{ shortDescription }}
                                <span v-if="isLongDescription">
                                    <button @click="toggleDescription" class="btn btn-link p-0 align-baseline w-0"
                                        style="font-size: inherit;">
                                        {{ showFullDescription ? ' Show Less' : ' Show More' }}
                                    </button>
                                </span>
                            </p>
                        </div>

                        <div v-if="isCompleted" class="certificate-btn d-flex justify-content-center align-items-center">
                            <button class="btn btn-outline-primary btn-sm align-items-center text-center" @click="getCertificate">
                                <i class="fa fa-arrow-down me-2"></i> Get Certificate
                            </button>
                        </div>
                    </div>
                </div>

                <!-- 3. Divider & Heading -->
                <hr />
                <div class="container px-0">
                    <div class="d-flex justify-content-between align-items-center">
                        <h3 class="mb-3 fs-5 fs-md-4">Course Content</h3>

                        <!-- 4. Toggle Button (Responsive) -->
                        <div class="mb-3 text-start text-md-end">
                            <button class="btn btn-outline-primary btn-sm d-none d-md-inline" @click="toggleAll">
                                {{ allExpanded ? 'Collapse All' : 'Expand All' }}
                            </button>

                            <!-- Icon button for small screens -->

                            <i :class="allExpanded ? 'fa fa-chevron-up d-md-none' : 'fa fa-chevron-down d-md-none'"
                                @click="toggleAll"></i>

                        </div>
                    </div>

                    <!-- 5. Accordion -->
                    <div id="lessonAccordion">
                        <div class="card mb-2" v-for="(lesson, index) in videoLessons" :key="lesson.id">
                            <div class="card-header d-flex justify-content-between align-items-center"
                                @click="showLesson(lesson.id)" style="cursor: pointer;">
                                <div class="d-flex align-items-center">
                                    <span class="me-3 fw-bold">{{ index + 1 }}</span>
                                    <div class="vr me-2 ml-1"></div>
                                    <span class="ml-2">{{ lesson.title }}</span>
                                </div>
                                <i class="fa fa-check-circle fs-5"
                                    :class="lesson.learningProgress.completedAt ? 'text-success' : 'text-muted'"></i>
                            </div>
                            <div v-show="expandedLessons.includes(lesson.id)" class="card-body">
                                <p class="mb-0">{{ lesson.description }}</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Card from '@/components/TrainingCourses/Card.vue';
import axios from 'axios';
import { eventBus } from "@/main";

export default {
    name: 'CourseDetail',
    components: { Card },
    data() {
        return {
            courseId: this.$route.params.courseId,
            courseHeroImageBlobUrl: null,
            imageLoading: true,
            course: null,
            videoLessons: [],
            loading: true,
            allExpanded: false,
            expandedLessons: [],
            fallbackThumbnail: require('@/assets/logo.png'),
            showFullDescription: false,
            descriptionLimit: 300,
            isCompleted: false,
        };
    },
    computed: {
        shortDescription() {
            if (!this.course || !this.course.description) return '';
            if (this.showFullDescription || this.course.description.length <= this.descriptionLimit) {
                return this.course.description;
            }
            return this.course.description.slice(0, this.descriptionLimit) + '...';
        },
        isLongDescription() {
            return this.course && this.course.description && this.course.description.length > this.descriptionLimit;
        },
    },
    async mounted() {
        await this.fetchVideoLessons();
        await this.fetchHeroImageWithAuth();
        this.loading = false;
        eventBus.$emit('changeTop', {
            title: this.course.title,
            simple: true,
            topLogo: false
        });
    },
    methods: {
        async fetchHeroImageWithAuth() {
            this.revokeThumbnailBlob();
            this.imageLoading = true;
            try {
                const blobUrl = await this.$store.dispatch('fetchThumbnailWithAuth', {
                    isCourse: true,
                    thumbnail: this.course.thumbnailUrl
                });
                this.courseHeroImageBlobUrl = blobUrl;
            } catch (e) {
                this.courseHeroImageBlobUrl = null;
            } finally {
                this.imageLoading = false;
            }
        },
        revokeThumbnailBlob() {
            if (this.courseHeroImageBlobUrl) {
                URL.revokeObjectURL(this.courseHeroImageBlobUrl);
                this.courseHeroImageBlobUrl = null;
            }
        },
        async fetchVideoLessons() {
            this.loading = true;
            try {
                const params = {
                    paginated: false,
                };
                const response = await axios.get(`/training-courses/${this.courseId}/video-lessons`, { params });
                this.videoLessons = response.data.videoLessons;
                this.course = response.data.course;
                this.isCompleted = this.course.learningProgress.status === 'completed' ?? false;

            } catch (error) {
                console.error('Error fetching video lessons:', error);
                this.videoLessons = [];
            } finally {
                this.loading = false;
            }
        },
        showLesson(lessonId) {
            this.$router.push({ name: 'staff.training-courses.video-lesson', params: { lessonId: lessonId } });
        },
        toggleAll() {
            if (this.allExpanded) {
                this.expandedLessons = [];
            } else {
                this.expandedLessons = this.videoLessons.map(lesson => lesson.id);
            }
            this.allExpanded = !this.allExpanded;
        },
        toggleDescription() {
            this.showFullDescription = !this.showFullDescription;
        },
        goToCourses() {
            this.$router.push({ name: 'staff.training-courses', params: {} });
        },
        getCertificate() {
            return ;
        }
    },
};
</script>
